import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

const BrandContext = createContext(null);
const KEY = "bh_brand";

export const BrandProvider = ({ children }) => {
  const [brand, setBrandState] = useState(sessionStorage.getItem(KEY) || "all");

  const setBrand = useCallback((next) => {
    sessionStorage.setItem(KEY, next);
    setBrandState(next);
  }, []);

  const value = useMemo(
    () => ({ brand, setBrand, brandParam: brand === "all" ? undefined : brand }),
    [brand, setBrand]
  );
  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
};

export const useBrand = () => {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error("useBrand debe usarse dentro de BrandProvider");
  return ctx;
};
